var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"email-us"},[_vm._v(_vm._s(_vm.$t('upgrade_page_views_static_email_us_index_2191')))])}
var staticRenderFns = []

export { render, staticRenderFns }